<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col-md-8 left">
          <div class="title">
            {{ $t('sidebar.appearance') }}
          </div>
        </div>
        <div class="col-md-4 right">
          <div class="action"/>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="!edited">
        <div class="click-to-shake">
          <section>
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.formats')"/>
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-row">
                    <div
                      class="col-md-12"
                      style="height: 24px;">
                      {{ $t('message.formatnumberandusecomma') }}
                    </div>
                    <div
                      class="form-group col-4"
                      style="padding-right: 0;">
                      <select
                        v-model="form.selectDecimalPlacesFormat"
                        class="custom-select form-control"
                        disabled
                        style="border-radius: .25rem 0 0 .25rem;">
                        <option value="0">{{ $t('message.decimalplaces', {number: 0}) }}</option>
                        <option value="1">{{ $t('message.decimalplaces', {number: 1}) }}</option>
                        <option value="2">{{ $t('message.decimalplaces', {number: 2}) }}</option>
                      </select>
                    </div>
                    <div
                      class="form-group col-4"
                      style="padding: 0;">
                      <div
                        class="box-input active"
                        style="border-radius: 0;">
                        <vs-checkbox
                          :disabled="true"
                          v-model="form.checkboxUsecomma"
                          color="#A3CA76"
                          style="float: left;position: relative;top: 1px;left: -5px;">
                          {{ $t('message.usecomma') }}
                        </vs-checkbox>
                      </div>
                    </div>
                    <div
                      class="form-group col-4"
                      style="padding-left: 0;">
                      <div class="box-input active">
                        {{ $t('message.formatnumberpreview', {string: previewFormatNumber}) }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('message.formatdate') }}</label>
                      <select
                        v-model="form.selectDateFormat"
                        class="custom-select form-control"
                        disabled>
                        <option value="YYYY/MM/DD">YYYY/MM/DD</option>
                        <option value="YYYY/DD/MM">YYYY/DD/MM</option>
                        <option value="DD/MM/YYYY">DD/MM/YYYY</option>
                        <option value="MM/DD/YYYY">MM/DD/YYYY</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.local')"/>
              <div class="form-row">
                <div class="col-md-6">
                  <label>{{ $t('message.currency') }}</label>
                  <select
                    v-model="form.selectCurrency"
                    class="custom-select form-control"
                    disabled>
                    <option
                      v-for="(item, index) in currencyOptions"
                      :key="index"
                      :value="item.value"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label>{{ $t('message.language') }}</label>
                  <select
                    v-model="form.selectLanguage"
                    class="custom-select form-control"
                    disabled>
                    <option value="en">English</option>
                    <option value="th">ภาษาไทย</option>
                  </select>
                </div>
              </div>
            </div>
          </section>
        </div>
      </template>

      <template v-if="edited">
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.formats')"/>
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-row">
                  <div
                    class="col-md-12"
                    style="height: 24px;">
                    {{ $t('message.formatnumberandusecomma') }}
                  </div>
                  <div
                    class="form-group col-4"
                    style="padding-right: 0;">
                    <select
                      v-model="form.selectDecimalPlacesFormat"
                      class="custom-select form-control"
                      style="border-radius: .25rem 0 0 .25rem;">
                      <option value="0">{{ $t('message.decimalplaces', {number: 0}) }}</option>
                      <option value="1">{{ $t('message.decimalplaces', {number: 1}) }}</option>
                      <option value="2">{{ $t('message.decimalplaces', {number: 2}) }}</option>
                    </select>
                  </div>
                  <div
                    class="form-group col-4"
                    style="padding: 0;">
                    <div class="box-input">
                      <vs-checkbox
                        v-model="form.checkboxUsecomma"
                        color="#A3CA76"
                        style="float: left;position: relative;top: 0;left: -5px;">
                        {{ $t('message.usecomma') }}
                      </vs-checkbox>
                    </div>
                  </div>
                  <div
                    class="form-group col-4"
                    style="padding-left: 0;">
                    <div class="box-input active">
                      {{ $t('message.formatnumberpreview', {string: previewFormatNumber}) }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.formatdate') }}</label>
                    <select
                      v-model="form.selectDateFormat"
                      class="custom-select form-control">
                      <option value="YYYY/MM/DD">YYYY/MM/DD</option>
                      <option value="YYYY/DD/MM">YYYY/DD/MM</option>
                      <option value="DD/MM/YYYY">DD/MM/YYYY</option>
                      <option value="MM/DD/YYYY">MM/DD/YYYY</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.local')"/>
            <div class="form-row">
              <div class="col-md-6">
                <label>{{ $t('message.currency') }}</label>
                <select
                  v-model="form.selectCurrency"
                  class="custom-select form-control">
                  <option
                    v-for="(item, index) in currencyOptions"
                    :key="index"
                    :value="item.value"
                  >
                    {{ item.text }}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <label>{{ $t('message.language') }}</label>
                <select
                  v-model="form.selectLanguage"
                  class="custom-select form-control">
                  <option value="en">English</option>
                  <option value="th">ภาษาไทย</option>
                </select>
              </div>
            </div>
          </div>
        </section>
        <section class="action-bar">
          <div
            v-if="!$store.state.app.loading"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" @click="edited = false">{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              @click="save()">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" disabled>{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </section>
      </template>

    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'

export default {
  name: 'SettingsAppearance',
  mixins: [discardFormMixin],
  data () {
    return {
      ready: false,
      edited: false,
      updated: false,
      form: {
        selectDecimalPlacesFormat: 0,
        checkboxUsecomma: false,
        selectDateFormat: null,
        selectCurrency: null,
        selectLanguage: null,
      },
      originalForm: null,
      currencyOptions: [
        {
          text: 'THB',
          value: 'THB',
        },
        {
          text: 'USD',
          value: 'USD',
        },
        {
          text: 'EUR',
          value: 'EUR',
        },
        {
          text: 'LAK',
          value: 'LAK',
        },
        {
          text: 'MMK',
          value: 'MMK',
        },
        {
          text: 'IDR',
          value: 'IDR',
        },
        {
          text: 'MYR',
          value: 'MYR',
        },
        {
          text: 'KHR',
          value: 'KHR',
        },
      ],
    }
  },
  computed: Object.assign(mapGetters({
    shopInfo: 'getShopInfo',
  }), {
    previewFormatNumber () {
      const decimalplaces = this.form.selectDecimalPlacesFormat
      const useComma = this.form.checkboxUsecomma
      const defaultNumber = 1500
      if (!useComma) {
        return defaultNumber.toFixed(decimalplaces)
      }
      return defaultNumber.toLocaleString('en-US', { minimumFractionDigits: decimalplaces })
    },
  }),
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    edited: function (after) {
      if (!this.edited && !this.updated) {
        this.form = this.getObject(this.originalForm)
      } else {
        this.updated = false
      }
    },
  },
  beforeCreate: function () {

  },
  created: function () {
    // set form
    this.form.selectDecimalPlacesFormat = this.shopInfo.settings.general.appearance.format_number.decimal.place
    this.form.checkboxUsecomma = this.shopInfo.settings.general.appearance.format_number.use_comma
    this.form.selectDateFormat = this.shopInfo.settings.general.appearance.format_date
    this.form.selectCurrency = this.shopInfo.settings.general.appearance.currency
    this.form.selectLanguage = this.$store.state.app.lang
    // set original form
    this.originalForm = this.getObject(this.form)

    // set ready
    this.ready = true

    // set edited
    this.edited = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.settings.title'),
      current: {
        app_name: 'settings',
        app_id: null,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 1,
    })
  },
  mounted: function () {

  },
  destroyed: function () {
    this.leavePage(this.$Progress, [])
  },
  methods: {
    async save () {
      let data = {
        'appearance': {
      		'currency': this.form.selectCurrency,
      		'decimal_places': parseInt(this.form.selectDecimalPlacesFormat),
      		'use_comma': this.form.checkboxUsecomma,
      		'date': this.form.selectDateFormat,
      	},
      }

      let res = await this.$store.dispatch('updateSettings', data)

      if (res.success) {
        /*
        ** set language
        */
        this.$i18n.locale = this.form.selectLanguage
        // switch lang
        this.$store.dispatch('switchLang', this.form.selectLanguage)
        // init page, set tab title with new language
        this.initPage({
          section: 'app',
          name: this.$t('app.settings.title'),
          current: {
            app_name: 'settings',
            app_id: null,
          },
        })
        /*
        ** set language done
        */

        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.saved'),
          color: 'success',
          icon: 'cloud',
        })
        // loading finish
        this.showFinish(this.$Progress)
        // set original form
        this.originalForm = this.getObject(this.form)
        // set edited
        this.edited = false

        this.$nextTick(() => {
          // set edited
          this.edited = true
        })
      }
    },
  },
}
</script>

<style scoped>
  .box-input {
    position: relative;
    padding-left: 7px;
    height: 35px;
    background: #fff;
    border: 1px solid #ced4da;
    border-left: none;
    color: #495057;
    line-height: 35px;
    border-radius: 0;
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .box-input.active {
    background: #e9ecef;
    border-radius: 0 .25rem .25rem 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/settings/appearance/All.vue